module.exports = __webpack_public_path__ + "static/media/28-1.cca1d6c3.mp3";